// extracted by mini-css-extract-plugin
export default {"container":"useChatConfig_container__nyl6R","firstCell":"useChatConfig_firstCell__YbJtp","selectedBar":"useChatConfig_selectedBar__jY56d"};